import React from "react";
import dummyImage from "assets/img/avatars/UserAvtar.png";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { IoLogOutSharp } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";

const Navbar = ({ onOpenSidenav, brandText, handleLogout }) => {
  const navigate = useNavigate();

  return (
    <nav className="sticky top-4 z-40 flex w-full items-center justify-between rounded-xl bg-white/10 px-4 py-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onOpenSidenav}
          className="mr-4 flex cursor-pointer items-center justify-center text-xl text-gray-600 dark:text-white xl:hidden"
          aria-label="Open side menu"
        >
          <FiAlignJustify className="h-6 w-6" />
        </button>
      </div>

      <div className="flex flex-1 justify-start">
        <p className="text-[28px] font-bold capitalize text-navy-700 dark:text-white">
          <Link to="#" className="hover:text-navy-700 dark:hover:text-white">
            {brandText}
          </Link>
        </p>
      </div>

      <div className="flex items-center gap-4">
        <Dropdown
          button={
            <img
              className="h-10 w-10 rounded-full"
              src={dummyImage}
              alt="User Avatar"
            />
          }
          classNames="py-2 top-8 -left-[180px] w-max"
          onclick={() => navigate("/admin/profile")}
        />
        <button
          onClick={handleLogout}
          className="cursor-pointer"
          aria-label="Logout"
        >
          <IoLogOutSharp className="h-7 w-7 text-gray-600 dark:text-white" />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
